import * as React from "react";
import { IconProps } from "./types";

export const AlignLeft01Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M3 3V21M21 12H7M7 12L14 19M7 12L14 5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(AlignLeft01Icon as React.FunctionComponent).displayName = "AlignLeft01Icon";

export default AlignLeft01Icon;
